<template>
  <v-container fluid class="light shadow-none" id="appBar">
    <v-row justify="space-between" align="center">

      <v-col sm="12" md="8" lg="8" class="d-none d-md-block overflow-hidden" style="height: 58px;">
        <v-fade-transition>
          <v-row align="center">
            <v-col cols="2" class="py-1" v-if="$store.state.topAppBar">
              <router-link to="/">
                <AnimatedLogo height="40px" />
              </router-link>
            </v-col>
            <v-col cols="auto" class="px-2" v-if="$store.state.topAppBar">
              <AppBarRoutesMenu />
            </v-col>
          </v-row>
        </v-fade-transition>

      </v-col>
      <v-col cols="12" md="4" sm="12" style="height: 58px;">
        <v-row justify="space-between" justify-md="end" align="center" justify-lg="end">
          <v-col cols="auto" class="d-md-none">
            <v-btn small @click.stop="toggleSidebar" :class="$vuetify.rtl == true ? '' : 'rotate-180'" fab 
              outlined elevation="0" height="26" width="26">
              <v-icon  size="20">mdi-menu</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto" class="d-md-none" @click="$router.push('/')">
            <img  src="@/assets/img/png/logo.png" style="max-height: 30px;"
              class="d-block ma-auto " alt="cement-POS" />
          </v-col>
          <v-col cols="auto">
            <v-row align="center" justify="end" justify-lg="end">
              <v-col cols="auto" class="d-none d-md-block">
                <v-btn v-on:click="changeLanguage" x-small fab class="bg-white d-block ma-auto" elevation="0">
                  <img src="@/assets/img/svg_icons/USA.svg" height="25" v-if="$vuetify.rtl == true" alt="cement" />
                  <img src="@/assets/img/svg_icons/KSA.svg" height="25" v-if="$vuetify.rtl == false" alt="cement" />
                </v-btn>
              </v-col>
              <v-col cols="auto" class="d-none d-md-block">
                <v-btn x-small fab elevation="0" v-on:click="dashboardView">
                  <v-icon v-if="!$store.state.topAppBar">mdi-view-compact</v-icon>
                  <v-icon v-if="$store.state.topAppBar">mdi-view-list</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="auto" class="d-none d-md-block">
                <v-btn x-small fab elevation="0" v-fullscreen="options">
                  <v-icon v-if="!fullscreen">mdi-fullscreen</v-icon>
                  <v-icon v-if="fullscreen">mdi-fullscreen-exit</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="auto" class="d-none d-md-block">
                <v-btn x-small fab @click="darkTheme" depressed>
                  <v-icon v-if="$store.state.Settings.darkTheme" color="yellow1">mdi-white-balance-sunny</v-icon>
                  <v-icon v-if="!$store.state.Settings.darkTheme">mdi-weather-night</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="auto" class="d-none d-md-block pa-0">
                <v-divider vertical style="height: 40px"></v-divider>
              </v-col>
              <v-col cols="auto">
                <UserMenu></UserMenu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pa-0 px-4">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserMenu from "./UserMenu.vue";
import AppBarRoutesMenu from "./AppBarRoutesMenu.vue";
import AnimatedLogo from "./AnimatedLogo.vue";
export default {
  name: "Appbar",
  computed: {
    options() {
      return {
        callback: (isFullscreen) => {
          this.fullscreen = isFullscreen;
        },
        target: ".directive-fullscreen-wrapper",
        pageOnly: this.pageOnly,
        teleport: this.teleport,
      };
    },
  },
  data() {
    return {
      fullscreen: false,
    };
  },
  components: {
    UserMenu,
    AnimatedLogo,
    AppBarRoutesMenu
  },
  methods: {
    darkTheme() {
      this.$store.dispatch("Settings/darkTheme");
    },
    toggleSidebar() {
      this.$store.state.sidebarIsOpen = !this.$store.state.sidebarIsOpen;
    },
    changeLanguage() {
      this.$store.dispatch("Settings/changeLanguage");
    },
    dashboardView() {
      localStorage.setItem('appBarNavigation', !this.$store.state.topAppBar)
      this.$store.state.topAppBar = !this.$store.state.topAppBar;
    },
  },
};
</script>

<style lang="scss" scoped>
#appBar {
  position: sticky;
  height: 60px;
  z-index: 55;
  top: 0;
  //width: 100vw !important;
  //left: 0 !important;
  //right: 0 !important;
  overflow: hidden;
  display: flex;
  //box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
}
</style>